import { CardProps } from '@/components/card/types';
import { HitAllResult } from '@/components/search/types';
import { AppConfig } from '@/utils/AppConfig';

export function mapPictureHit(hit: HitAllResult): CardProps {
  return {
    title: hit.title,
    category: hit.category || '',
    description: hit.description,
    callToActionUrl: {
      url: hit?.id
        ? `/photos/${hit?.id.toString().replace('ffbbnational_galeries_', '') || ''}`
        : '',
      slug: '',
      external: false,
    },
    photoCount: hit.count || 0,
    image: hit?.thumbnail || '',
    imageAlt: hit?.title || '',
    titleUppercase: !hit?.thumbnail ? true : false,
    titleCustomFont: true,
    displayDescription: !hit?.thumbnail ? true : false,
    isoDate: hit?.date_published || '',
  };
}
